import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useState } from 'react';
import { captureError, Severity } from '@chegg/observability';
import { client } from '@chegg/pricing-sdk';
import { noop } from '@chegg/utils';
import getNextInteractionPayload from '../utils/getNextInteractionPayload';
import { CW_TEAM_NAME } from '../constants/Strings';
export var ERROR_LOCATION = 'useGetNextInteractionAsync';

/**
 * Hook that constructs nextInteraction payload and fetches the nextInteraction from the Pricing SDK
 */
var useGetNextInteractionAsync = function useGetNextInteractionAsync(_ref) {
  var authorizePayload = _ref.authorizePayload,
    nextInteractionPayload = _ref.nextInteractionPayload,
    pricing = _ref.pricing,
    _ref$skip = _ref.skip,
    skip = _ref$skip === void 0 ? false : _ref$skip,
    _ref$errorLocation = _ref.errorLocation,
    errorLocation = _ref$errorLocation === void 0 ? ERROR_LOCATION : _ref$errorLocation;
  var updatedNextInteractionPayload = getNextInteractionPayload(_objectSpread(_objectSpread({}, nextInteractionPayload), {}, {
    pricingData: pricing
  }));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];

  // Assumes pricing sdk authorize has already been called
  var getNextInteraction = client.nextInteractionApi.getNextInteraction;
  useEffect(function () {
    if (skip) {
      return noop();
    }
    if (!!updatedNextInteractionPayload && !data && !error && !loading) {
      setLoading(true);
      var request = _objectSpread(_objectSpread({}, updatedNextInteractionPayload), {}, {
        authorizeParams: authorizePayload
      });
      getNextInteraction(request).then(function (response) {
        var _response$errors;
        setData(response);
        if ((_response$errors = response.errors) !== null && _response$errors !== void 0 && _response$errors.length) {
          response.errors.forEach(function (err) {
            captureError({
              severity: Severity.CRITICAL,
              error: new Error("Type: ".concat(err.type, " Code: ").concat(err.code, " Message: ").concat(err.message)),
              location: errorLocation
            }, {
              teamName: CW_TEAM_NAME
            });
          });
        }
      })["catch"](function (errorResponse) {
        var _errorResponse$errors;
        setError(errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.errors);
        errorResponse === null || errorResponse === void 0 || (_errorResponse$errors = errorResponse.errors) === null || _errorResponse$errors === void 0 || _errorResponse$errors.forEach(function (err) {
          captureError({
            error: err,
            location: errorLocation,
            severity: Severity.ERROR
          }, {
            teamName: CW_TEAM_NAME
          });
        });
      })["finally"](function () {
        setLoading(false);
      });
    }
  }, [updatedNextInteractionPayload, skip, data, error, loading]);
  if (skip) {
    return {
      status: 'skipped'
    };
  }
  if (loading) {
    return {
      status: 'loading'
    };
  }
  if (!data && error) {
    return {
      status: 'error',
      metadata: error
    };
  }
  return {
    status: 'ok',
    data: data
  };
};
export default useGetNextInteractionAsync;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useGetNextInteractionAsync.js
// module id = 4068
// module chunks = 11